// Default "Link Name" for a share link: the shared file/page's name plus when
// its link was generated - e.g. "Invoice #ZQX-001 - 2026-10-16 00:20".
// Mirrors express-server document-service.js's createDocumentLink default
// (formatLinkTimestamp: "YYYY-MM-DD HH:mm" in UTC) so every link's default
// reads the same way, whichever kind it is.
export const defaultLinkName = (title: string, generatedAt: string | Date | null | undefined): string => {
    const date = generatedAt ? new Date(generatedAt) : null;
    if (!date || isNaN(date.getTime())) return title;
    const pad = (n: number) => String(n).padStart(2, '0');
    const stamp = `${date.getUTCFullYear()}-${pad(date.getUTCMonth() + 1)}-${pad(date.getUTCDate())} ${pad(date.getUTCHours())}:${pad(date.getUTCMinutes())}`;
    return `${title} - ${stamp}`;
};
